import { render, staticRenderFns } from "./HandoverEdit.vue?vue&type=template&id=004cf3e4&scoped=true"
import script from "./HandoverEdit.vue?vue&type=script&lang=js"
export * from "./HandoverEdit.vue?vue&type=script&lang=js"
import style0 from "./HandoverEdit.vue?vue&type=style&index=0&id=004cf3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004cf3e4",
  null
  
)

export default component.exports